<template>
  <div class="row">
    <div class="col-md-3">
      <form class="needs-validation" ref="form" id="form">
        <!-- part for qs -->
        <div class="mb-2 form-group">
          <label class="mb-0" for="Operator">Qualitätsmitarbeiter/In: </label>
          <select class="form-control" v-model="qsEmployee" required>
            <option
              v-for="qsEmployee in qsEmployees"
              :key="qsEmployee.id"
              :value="qsEmployee.id"
            >
              {{ qsEmployee.username }}
            </option>
          </select>
        </div>

        <!-- part for isGlassCleaned -->
        <div class="mb-2 form-check">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="isGlassCleaned"
            value=""
            id="GlassCleaned"
          />
          <label class="form-check-label" for="GlassCleaned">
            Glas gereingt?
          </label>
        </div>

        <!-- part for test like. -->
        <div class="form-group">
          <label class="mb-" for="TestLike">Hafttest entspricht :</label>
          <input
            type="text"
            class="form-control mb-2"
            v-model="testLike"
            id="TestLike"
            placeholder="MSII Black L"
            required
          />
        </div>

        <!-- part for tests  -->
        <div class="form-group">
          <label class="mb-2">Laminatortest: </label>
          <div v-for="(test, id) in tests" :key="id">
            <input
              type="radio"
              :id="id"
              v-model="selectedTest"
              :value="test.value"
              class="radio-input mb-2"
            />
            <label :for="id">{{ test.text }}</label>
          </div>
        </div>

        <!-- part for laminator 1 / 2 / 3 -->
        <div class="form-group">
          <label>Laminator: </label>
          <div v-for="(laminator, id) in laminators" :key="id">
            <input
              type="radio"
              :id="id"
              v-model="selectedLaminator"
              :value="laminator.value"
              class="radio-input mb-2"
            />
            <label :for="id">{{ laminator.text }}</label>
          </div>
        </div>

        <!-- part for position  1 / 2 / 3 / 4 -->
        <div class="form-group">
          <label>Position auf dem Einfuhrtisch: </label>
          <div v-for="(position, id) in positions" :key="id">
            <input
              type="radio"
              :id="id"
              v-model="selectedPosition"
              :value="position.value"
              class="radio-input mb-2"
            />
            <label :for="id">{{ position.text }}</label>
          </div>
        </div>

        <!-- Lami Programm -->
        <div class="form-group">
          <label>Lami Programm:</label>
          <div>
            <div>
              <input
                class="radio-input"
                type="radio"
                v-model="lamiProgramme"
                value="GBS"
                id="lamiRecipe"
              />
              <label>GBS</label>
            </div>
            <div>
              <input
                class="radio-input"
                type="radio"
                name="lamiProgramme"
                id="radioOther1"
                value="true"
                @change="enableInputFieldLami"
              />
              <label class="form-check-label mb-2" for="radioOther1">
                andere
              </label>
            </div>

            <input
              class="form-control"
              type="text"
              name="glassType"
              v-model="lamiProgramme"
              id="inputFieldLami"
              v-show="isInputFieldLamiVisible"
            />
          </div>
        </div>

        <!-- Backsheet Typ  -->
        <div class="form-group">
          <label class="mb-2">Backsheet Typ:</label>
          <div>
            <div>
              <input
                class="radio-input"
                type="radio"
                v-model="backsheetType"
                name="backsheetType"
                id="backsheetType"
                value="Cynagard205A"
              />
              <label>Cynagard205A</label>
            </div>
            <div>
              <input
                class="radio-input"
                type="radio"
                name="backsheetType"
                id="radioOther2"
                value="true"
                @change="enableInputFieldBacksheet"
              />
              <label class="form-check-label mb-2" for="radioOther2">
                andere
              </label>
            </div>

            <input
              class="form-control"
              type="text"
              name="glassType"
              v-model="backsheetType"
              id="inputFieldBacksheet"
              v-show="isInputFieldBacksheetVisible"
            />
          </div>
        </div>

        <!-- part for backsheet batchnumber. -->
        <div class="form-group">
          <label class="mb-0" for="BackSheetNumber"
            >Backsheet Charge Nr.:</label
          >
          <input
            type="text"
            class="form-control mb-2"
            v-model="backsheetBatchNumber"
            id="BackSheetNumber"
            required
          />
        </div>

        <!-- EVA Typ  -->
        <div class="form-group">
          <label>EVA Typ:</label>
          <div>
            <div>
              <input
                class="radio-input"
                type="radio"
                name="evaType"
                id="evaType"
                v-model="evaType"
                value="First EVA F406PS"
              />
              <label>First EVA F406PS</label>
            </div>
            <div>
              <input
                class="radio-input"
                type="radio"
                name="evaType"
                id="radioOther3"
                value="true"
                @change="enableInputFieldEvaType"
              />
              <label class="form-check-label mb-2" for="radioOther3">
                andere
              </label>
            </div>

            <input
              class="form-control"
              type="text"
              name="evaType"
              v-model="evaType"
              id="inputFieldEvaType"
              v-show="isInputFieldEvaTypeVisible"
            />
          </div>
        </div>

        <!-- part for eva batchnumber. -->
        <div class="form-group">
          <label class="mb-0" for="EvaBatchNumber">Eva Charge Nr.:</label>
          <input
            type="text"
            class="form-control"
            v-model="evaBatchNumber"
            id="EvaBatchNumber"
            required
          />
        </div>

        <!-- part for glass thickness  -->
        <div class="form-group">
          <label class="mb-2">Frontglass Dicke:</label>
          <div>
            <div>
              <input
                class="radio-input"
                type="radio"
                name="glassThickness"
                id="glassThick"
                v-model="glassThickness"
                value="5"
              />
              <label>5mm</label>
            </div>
            <div>
              <input
                class="radio-input"
                type="radio"
                name="glassThickness"
                id="radioOther4"
                value="true"
                @change="enableInputFieldGlassThickness"
              />
              <label class="form-check-label mb-2" for="radioOther4">
                andere
              </label>
            </div>

            <input
              class="form-control mb-2"
              type="text"
              name="glassThickness"
              placeholder="4mm"
              v-model="glassThickness"
              id="inputFieldGlassThickness"
              v-show="isInputFieldGlassThicknessVisible"
            />
          </div>
        </div>

        <!-- part for glass batchnumber. -->
        <div class="form-group">
          <label class="mb-0" for="GlassBatchNumber"
            >Frontglas Charge Nr.:</label
          >
          <input
            type="text"
            class="form-control mb-2"
            v-model="glassBatchNumber"
            id="GlassBatchNumber"
            required
          />
        </div>

        <!-- datePicker for glass manufacturingDate -->
        <div class="mb-3 form-group">
          <label class="mb-0" for="production">{{ datePickerLabel }}</label>
          <VueDatePicker
            class="b-form-datepicker"
            v-model="glassManufacturingDate"
            :enable-time-picker="false"
            required
            >{{ glassManufacturingDate }}</VueDatePicker
          >
        </div>

        <br />
        <!-- part for the adhesiontests -->
        <div class="row">
          <div>
            <p><b>Haftest [N]</b></p>
          </div>
          <div class="col-md-6">
            <!-- part for adhseionTestGlass. -->
            <div class="form-group">
              <label class="mb-0" for="AdhesionTestGlass"
                >Glas (mind. 80N):</label
              >
              <div
                v-for="(inputGlass, index) in adhesionGlassInputs"
                :key="index"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="adhesionGlassInputs[index]"
                  :id="`AdhesionTest${index}`"
                  placeholder="82.2"
                  :required="index < 5"
                />
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <!-- part for adhseionTestBacksheet. -->
            <div class="form-group">
              <label class="mb-0" for="AdhesionTestBacksheet"
                >Backsheet: (mind. 60N)</label
              >
              <div
                v-for="(input, index) in adhesionBacksheetInputs"
                :key="index"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="adhesionBacksheetInputs[index]"
                  :id="`AdhesionTest${index}`"
                  placeholder="74.6"
                  :required="index < 5"
                />
              </div>
            </div>
          </div>
        </div>

        <button
          type="button"
          class="btn btn-primary mb-3 mt-4"
          @click="submit()"
        >
          Speichern
        </button>
      </form>

      <!-- success alert -->
      <transition name="alert">
        <div
          class="alert alert-success mt-1"
          role="alert"
          v-if="triggerSuccess"
        >
          Der Eintrag wurde gespeichert!
        </div>
      </transition>

      <!-- failed alert -->
      <transition name="alert">
        <div class="alert alert-danger mt-1" role="alert" v-if="triggerError">
          Eintrag konnte nicht gespeichert werden!
        </div>
      </transition>

      <!-- form invalid alert -->
      <transition name="alert">
        <div
          class="alert alert-warning mt-1"
          role="alert"
          v-if="triggerWarning"
        >
          Bitte füllen Sie alle Felder aus!
        </div>
      </transition>
    </div>

    <div class="col-md-9">
      <FoilPeelTable :url-foil-peel-data="props.urlData" :key="componentKey" />
    </div>
  </div>

  <!-- some test is not good -->
  <transition name="modal">
    <template v-if="showModal && triggerAdhesionTestInvalid">
      <MyModal :msg="modalInformQS" :visible="showModal">
        <template #declined>
          <button
            type="button"
            id="declined"
            class="btn btn-warning"
            @click="handleModalButton(false)"
          >
            Abbrechen
          </button>
        </template>
      </MyModal>
    </template>
  </transition>
</template>

<script setup>
import { onMounted, ref, defineProps } from "vue";
import FoilPeelTable from "@/components/foilpeel/FoilPeelTable.vue";
import MyModal from "@/components/helpers/MyModal.vue";
import moment from "moment-timezone";
import { instance as axios } from "@/services/axios";

const props = defineProps({
  stationId: {
    type: Number,
    required: true,
  },
  urlData: {
    type: String,
    required: true,
  },
});

const getRequestJobs = `/User/GetUsersByJobtype/5`;
const postRequestUrl = `/Material/AddFoilPeel`;

const componentKey = ref(0);
const modalInformQS = "Bitte melden Sie sich umgehend bei QS!";
const datePickerLabel = "Frontglass Produktionsdatum:";

// Inputs for the "Hafttest" Glass and Backsheet
const adhesionBacksheetInputs = ref(Array(7).fill(""));
const adhesionGlassInputs = ref(Array(7).fill(""));

let testLike = ref();
let lamiProgramme = ref("");
let backsheetType = ref("");
let backsheetBatchNumber = ref();
let evaType = ref("");
let evaBatchNumber = ref();
let glassThickness = ref();
let glassBatchNumber = ref();
let glassManufacturingDate = ref();

// type of the tests
let tests = ref([
  { id: 1, text: "Produktionstest", value: "1" },
  { id: 2, text: "WEK EVA", value: "2" },
  { id: 3, text: "WEK Backsheet", value: "3" },
  { id: 4, text: "WEK Glas", value: "4" },
]);
let selectedTest = ref("");

let laminators = ref([
  { id: 1, text: "Laminator 1 (JT)", value: 26 },
  { id: 2, text: "Laminator 2 (NG)", value: 28 },
  { id: 3, text: "Laminator 3 (NG)", value: 56 },
]);
let selectedLaminator = ref("");

// Position "Einfuhrtisch"
let positions = ref([
  { id: 1, text: "1", value: 1 },
  { id: 2, text: "2", value: 2 },
  { id: 3, text: "3", value: 3 },
  { id: 4, text: "4", value: 4 },
]);
let selectedPosition = ref("");

let isGlassCleaned = ref(false);

const qsEmployee = ref();
const qsEmployees = ref([]);

// trigger values for alerts
let triggerSuccess = ref(false);
let triggerError = ref(false);
let triggerWarning = ref(false);
let triggerAbort = ref(false);
let triggerAdhesionTestInvalid = ref(false);

let showModal = ref(false);
let modalResolve;

const handleModal = () => {
  showModal.value = true;
  return new Promise((resolve) => {
    modalResolve = resolve;
  });
};

let isInputFieldLamiVisible = ref(false);
let isInputFieldBacksheetVisible = ref(false);
let isInputFieldEvaTypeVisible = ref(false);
let isInputFieldGlassThicknessVisible = ref(false);

const handleModalButton = (value) => {
  showModal.value = false;
  modalResolve(value);
};

const enableInputFieldLami = () => {
  lamiProgramme.value = null;
  isInputFieldLamiVisible.value = true;
};

const enableInputFieldBacksheet = () => {
  backsheetType.value = null;
  isInputFieldBacksheetVisible.value = true;
};

const enableInputFieldEvaType = () => {
  evaType.value = null;
  isInputFieldEvaTypeVisible.value = true;
};

const enableInputFieldGlassThickness = () => {
  glassThickness.value = null;
  isInputFieldGlassThicknessVisible.value = true;
};

const disableInputFields = () => {
  isInputFieldLamiVisible.value = false;
  isInputFieldBacksheetVisible.value = false;
  isInputFieldEvaTypeVisible.value = false;
  isInputFieldGlassThicknessVisible.value = false;
};

const createAdhesionObject = (inputs, prefix) => {
  const adhesionObject = {};
  inputs.forEach((value, index) => {
    const key = `${prefix}${String(index + 1).padStart(2, "0")}`;
    adhesionObject[key] = value.trim() === "" ? 0 : parseFloat(value);
  });
  return adhesionObject;
};

const checkMinimumInputs = (inputs) => {
  return inputs.filter((input) => input.trim() !== "").length >= 5;
};

onMounted(() => {
  axios
    .get(getRequestJobs)
    .then(({ data }) => {
      qsEmployees.value = data
        .map(({ id, username }) => ({ id, username }))
        .sort((a, b) => a.username.localeCompare(b.username));
    })
    .catch((error) => console.log(error.message));
});

// reset the form after submit it
function resetForm() {
  qsEmployee.value = null;
  adhesionBacksheetInputs.value = Array(7).fill("");
  adhesionGlassInputs.value = Array(7).fill("");
  selectedLaminator.value = null;
  selectedPosition.value = null;
  selectedTest.value = null;
  backsheetBatchNumber.value = null;
  glassBatchNumber.value = null;
  lamiProgramme.value = "";
  backsheetType.value = "";
  evaType.value = "";
  glassThickness.value = "";
  glassManufacturingDate.value = null;
  evaBatchNumber.value = null;
  testLike.value = null;
  componentKey.value += 1;
  document.getElementById("GlassCleaned").checked = false;
  document.getElementById("radioOther1").checked = false;
  document.getElementById("radioOther2").checked = false;
  document.getElementById("radioOther3").checked = false;
  document.getElementById("radioOther4").checked = false;
  disableInputFields();
}

//  submit the form for adding a new string peel
async function submit() {
  const currentDate = moment().tz("Europe/Zurich").format();

  if (
    !checkMinimumInputs(adhesionBacksheetInputs.value) ||
    !checkMinimumInputs(adhesionGlassInputs.value)
  ) {
    //warning alert
    triggerWarning.value = true;
    setTimeout(() => (triggerWarning.value = false), 5000);
    return;
  } else if (
    adhesionGlassInputs.value.some((input) => parseFloat(input) < 80) ||
    adhesionBacksheetInputs.value.some((input) => parseFloat(input) < 60)
  ) {
    triggerAdhesionTestInvalid.value = true;
    const modalResult = await handleModal();
    if (!modalResult) {
      // abort alert
      triggerAbort.value = true;
      setTimeout(() => (triggerAbort.value = false), 5000);
      return;
    }
  }
  if (
    qsEmployee.value == null ||
    testLike.value == null ||
    selectedTest.value == null ||
    selectedLaminator.value == null ||
    selectedPosition.value == "" ||
    lamiProgramme.value == "" ||
    backsheetType.value == "" ||
    backsheetBatchNumber.value == "" ||
    evaType.value == "" ||
    evaBatchNumber.value == "" ||
    glassThickness.value == "" ||
    glassManufacturingDate.value == "" ||
    glassBatchNumber.value == "" ||
    selectedLaminator.value == ""
  ) {
    //warning alert
    triggerWarning.value = true;
    setTimeout(() => (triggerWarning.value = false), 5000);
    return;
  }
  const adhesionEva = createAdhesionObject(adhesionGlassInputs.value, "G");
  const adhesionBacksheet = createAdhesionObject(
    adhesionBacksheetInputs.value,
    "R"
  );

  let jsonObject = {
    operatorid: qsEmployee.value,
    stationid: props.stationId,
    dateInProduction: currentDate,
    testType: selectedTest.value,
    testForArticle: testLike.value,
    isGlassCleaned: isGlassCleaned.value,
    laminatorStationId: selectedLaminator.value,
    laminatorRecipe: lamiProgramme.value,
    frontGlassThickness: glassThickness.value,
    frontGlassBatchNumber: glassBatchNumber.value,
    frontGlassManufacturingDate: glassManufacturingDate.value,
    evaFoilType: evaType.value,
    evaFoilBatchNumber: evaBatchNumber.value,
    evaFoilManufacturingDate: currentDate,
    backsheetType: backsheetType.value,
    backsheetTypeBatchNumber: backsheetBatchNumber.value,
    laminatorPosition: selectedPosition.value,
    adhesionEva: adhesionEva,
    adhesionBacksheet: adhesionBacksheet,
  };

  //   // json object for the POST-Request
  try {
    await axios.post(postRequestUrl, jsonObject);
    resetForm();
  } catch (e) {
    console.error("Ein Fehler ist aufgetreten:", e.message);
    setTimeout(() => (triggerError.value = false), 5000);
  }
  triggerSuccess.value = true;
  setTimeout(() => (triggerSuccess.value = false), 5000);
}
</script>

<style>
.alert-enter-active,
.alert-leave-active,
.modal-enter-active {
  transition: opacity 0.5s ease;
}
.alert-enter-from,
.alert-leave-to,
.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

input[type="radio"] {
  transform: scale(1.3);
}
input[type="checkbox"] {
  transform: scale(1.2);
}
.radio-input {
  margin-right: 10px; /* Abstand zwischen dem Radio-Button und dem Label */
}
</style>
